import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { logEvent, trackMetaEvent } from '../analytics';

const FALLBACK_IMAGE = 'https://images.unsplash.com/photo-1559056199-641a0ac8b55e?w=480&q=80';

export default function ProductItem({ product }) {
  const { id, name, nameHebrew, description, price, image, intensity, slug } = product;

  const [showModal, setShowModal] = useState(false);
  const [showEmailInput, setShowEmailInput] = useState(false);
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);
  const [submitError, setSubmitError] = useState(false);

  const imgSrc = image ? `${process.env.PUBLIC_URL}${image}` : FALLBACK_IMAGE;

  function handleBuy() {
    logEvent(`click_buy_${id}`);
    trackMetaEvent('AddToCart', {
      content_name: name,
      content_ids: [id],
      content_type: 'product',
      value: price,
      currency: 'ILS',
    });
    setShowModal(true);
  }

  async function handleSubmitEmail(e) {
    e.preventDefault();
    if (!email) return;

    logEvent(`lead_signup_${id}`, { label: email });
    trackMetaEvent('Lead', { content_name: name, content_ids: [id] });

    try {
      const formData = new URLSearchParams();
      formData.append('form-name', `notify-${id}`);
      formData.append('product-id', id);
      formData.append('email', email);

      await fetch('/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formData.toString(),
      });
    } catch {
      // Netlify Forms only work on deployed site
    }

    setSubscribed(true);
    setSubmitError(false);
  }

  return (
    <div className="product-item">
      <Link
        to={`/product/${slug || id}`}
        className="product-expand-link"
        aria-label={`פרטים נוספים על ${nameHebrew}`}
        onClick={() => logEvent(`expand_product_${id}`)}
      >
        <svg className="expand-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="15 3 21 3 21 9" />
          <polyline points="9 21 3 21 3 15" />
          <line x1="21" y1="3" x2="14" y2="10" />
          <line x1="3" y1="21" x2="10" y2="14" />
        </svg>
      </Link>

      <div className="product-image-wrap">
        <img src={imgSrc} alt={name} className="product-image" />
      </div>
      <div className="product-info">
        <h3 className="product-name">{nameHebrew}</h3>
        <p className="product-name-en">{name}</p>
        <p className="product-description">{description}</p>
        {intensity && (
          <div className="product-intensity">
            <span className="intensity-label">עוצמה</span>
            <div className="intensity-dots">
              {[1, 2, 3, 4, 5].map((level) => (
                <span
                  key={level}
                  className={`intensity-dot ${level <= intensity ? 'active' : ''}`}
                />
              ))}
            </div>
            <span className="intensity-value">{intensity}/5</span>
          </div>
        )}
        <p className="product-price">₪{price}</p>
        <div className="product-actions">
          <button className="btn btn-primary" onClick={handleBuy}>
            קנייה מהירה
          </button>
          <button className="btn btn-promo" onClick={handleBuy}>
            3 ב-₪330 + משלוח חינם
          </button>

        </div>
      </div>

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setShowModal(false)}>
              ✕
            </button>
            <div className="modal-icon">🚢</div>
            <p className="modal-text">
              אופס, המלאי אזל זמנית! המשלוח הטרי מגרמניה נמצא כרגע בלב ים
              וצפוי להגיע בקרוב. שווה לחכות!
            </p>

            {!showEmailInput && !subscribed && (
              <button
                className="btn btn-accent"
                onClick={() => setShowEmailInput(true)}
              >
                עדכנו אותי כשהמלאי חוזר
              </button>
            )}

            {showEmailInput && !subscribed && (
              <form className="notify-form" onSubmit={handleSubmitEmail}>
                <input
                  type="email"
                  name="email"
                  className="email-input"
                  placeholder="הזינו אימייל"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
                <button type="submit" className="btn btn-accent">
                  שילחו לי עדכון
                </button>
                {submitError && (
                  <p className="error-message">שגיאה בשליחה, נסו שנית.</p>
                )}
              </form>
            )}

            {subscribed && (
              <p className="success-message">
                נרשמת בהצלחה! נעדכן אותך ברגע שהפולים נוחתים בארץ.
              </p>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
